import React, { useCallback } from 'react'
import { Repeat04Icon } from 'src/editor/shared/icons/repeat-04-icon'
import {
  ButtonSizeEnum,
  GhostIconButton,
} from 'src/editor/shared/ui-lib/buttons'
import { Input } from 'src/editor/shared/ui-lib/input'
import { NumberInput } from 'src/editor/shared/ui-lib/input/number-input'
import { ReactColorChangeResult } from 'src/shared/types/color-typings'

export interface ColorPickerFields {
  hex: string
  opacity?: number
  handleRestore: () => void
  handleOpacityChange: (opacity: number) => void
  handleColorChange: (colorResult: ReactColorChangeResult) => void
}

export type ColorPickerFieldsDisplayStyle = 'hex' | 'rgb' | 'hsl'

export const ColorPickerFields = ({
  hex,
  opacity = 100,
  handleRestore,
  handleOpacityChange,
  handleColorChange,
}: ColorPickerFields) => {
  const handleHexInputChange = useCallback(
    (hex: string) => {
      handleColorChange({ hex, source: 'hex' })
    },
    [handleColorChange],
  )

  return (
    <div className="mt-4 flex flex-row items-center justify-between gap-3">
      <Input
        name="hex-color"
        startElement={
          <span className="select-none text-M text-textTertiary">#</span>
        }
        className="h-8 w-full"
        value={hex}
        onChange={handleHexInputChange}
        type="text"
      />
      <NumberInput
        name="color-transparency"
        hideControls
        endElement={
          <span className="pointer-events-none select-none text-M text-textTertiary">
            %
          </span>
        }
        className="h-8 w-3/5"
        value={opacity}
        onChange={(value: number) => handleOpacityChange(value / 100)}
        step={1}
        min={0}
        max={100}
      />
      <GhostIconButton
        onClick={handleRestore}
        icon={<Repeat04Icon />}
        size={ButtonSizeEnum.Small}
      />
    </div>
  )
}
